import React from "react";
import { Controller } from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";

interface TextAreaProps {
  label: string;
  name: string;
  control: any;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  name,
  control,
  placeholder = "",
  required = false,
  error,
}) => {
  return (
    <div className="w-full text-left relative">
      <label className="block font-Mulish text-base font-normal text-lightBlue mb-1">
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{ required: required ? "This field is required" : false }}
        render={({ field }) => (
          <textarea
            {...field}
            placeholder={placeholder}
            className={`w-full px-4 py-4 border-2 font-Mulish rounded-[10px] focus:outline-none placeholder-gray-400 resize-none
  ${error ? "border-red-500 ring-red-500" : "border-[#EAECF0]"}`}
          />
        )}
      />
      {error && (
        <ErrorsMessage
          title={error as string}
          className="absolute top-[94%] right-0"
        />
      )}
    </div>
  );
};

export default TextArea;
